<!-- <div class="shared-request-container container" *ngIf="sessionId">
</div> -->
<concourse-approval-request *ngIf="sessionId" [isModal]="false" [sessionId]="sessionId"></concourse-approval-request>